export const overwriteDefaults = {
  organization : {
    // Overwrite default errors
    httpHandlers : {
      conflict : {
        unit : 'Der Nutzer existiert bereits.'
      }
    }
  }
};
